/** @description Сценарии и этапы при работе с баннерами адфокс */
export var EAdfoxAnalyticsPayloadType = /*#__PURE__*/function (EAdfoxAnalyticsPayloadType) {
  EAdfoxAnalyticsPayloadType["WithoutAdfoxData"] = "withoutAdfoxData";
  EAdfoxAnalyticsPayloadType["WithAdfoxData"] = "withAdfoxData";
  EAdfoxAnalyticsPayloadType["WithAdfoxErrorData"] = "withAdfoxErrorData";
  EAdfoxAnalyticsPayloadType["ErrorWithAdfoxData"] = "errorWithAdfoxData";
  return EAdfoxAnalyticsPayloadType;
}({});